<template>
  <div class="emoji-picker-container">
    <font-awesome-icon v-if="isExist"  :icon="'times-circle'" :class="waiting ? 'plus__icon text-danger pointer-not-allowed' :'plus__icon text-danger pointer'"   style="position: absolute;right: 0;top: 5px; font-size: 12px;z-index: 1000"   @click="waiting ? null : selectEmoji('', $event)"/>
      <button v-if="isExist" :class="waiting ? 'emoji-button pointer-not-allowed':'emoji-button'" @click="togglePicker" ref="emojiPicker" @wheel.stop @touchmove.stop @click.stop :disabled="waiting">{{ selectedEmoji }}</button>
    <button v-else :class="waiting ? 'emoji-default-button pointer-not-allowed' : 'emoji-default-button'" @click="togglePicker" ref="emojiPicker" @wheel.stop @touchmove.stop @click.stop :disabled="waiting"><b-img src="/images/emoji-add.svg" width="30"
                                                                                                                                                                                                                     class="rounded img-fluid mr-1 emoji-img" /></button>
    <div v-if="isPickerVisible" class="emoji-picker" ref="emojiPicker">
      <div class="emoji-categories">
        <button
            v-for="category in emojiGroups"
            :key="category.group"
            @click="selectCategory(category.group, $event)"
            :class="{'active': activeCategory === category.group}"
        >
          {{ category.description }}
        </button>
      </div>
      <div class="emoji-list" ref="emojiList">
        <div
            v-for="emoji in filteredEmojis"
            :key="emoji.unicode"
            class="emoji-item"
            @click="selectEmoji(emoji.unicode, $event)"
        >
          {{ emoji.unicode }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomEmojiPicker",
  props: {
    allEmojis: {
      type: Array,
      required: true,
    },
    emojiGroups: {
      type: Array,
      required: true,
    },
    defaultEmoji: {
      type: String,
      default: "☺",
    },
    existReaction:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedEmoji: this.defaultEmoji,
      isPickerVisible: false,
      isExist : this.existReaction,
      waiting : false,
      activeCategory: 0,
    };
  },
  created() {
    if (!window.currentEmojiPicker) {
      window.currentEmojiPicker = null;
    }
  },
  computed: {

    filteredEmojis() {
      const selectedCategoryEmojis = this.allEmojis.find(
          (group) => group.group === this.activeCategory
      );
      return selectedCategoryEmojis ? selectedCategoryEmojis.emojiList : [];
    },
  },
  methods: {
    togglePicker() {
      if (window.currentEmojiPicker && window.currentEmojiPicker !== this) {
        window.currentEmojiPicker.isPickerVisible = false;
      }
      const messageList = document.querySelector(".message-list");
      if (!messageList) return;
      const { scrollTop, scrollHeight, clientHeight } = messageList;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      const isAtTop = scrollTop <= 5;
      this.isPickerVisible = !this.isPickerVisible;
      if (this.isPickerVisible) {
        window.currentEmojiPicker = this;
      } else {
        window.currentEmojiPicker = null;
      }
      this.$nextTick(() => {
        const emojiPicker = this.$refs.emojiPicker;
        if (emojiPicker) {
          if (isAtBottom && !isAtTop) {
            emojiPicker.classList.add("emoji-position-bottom");
          } else {
            emojiPicker.classList.remove("emoji-position-bottom");
          }
        }
      });
    },

    selectCategory(group) {
      this.activeCategory = group;
      event.preventDefault();
    },

    selectEmoji(emoji) {
      this.isPickerVisible = false;
      this.waiting = true
      console.log('click to remove')
      this.$emit('emojiUnicodeAdded', emoji);
      event.preventDefault();
    },
    closePickerIfClickedOutside(event) {
      if (this.$refs.emojiPicker && !this.$refs.emojiPicker.contains(event.target) && !this.$el.contains(event.target)) {
        this.isPickerVisible = false;
        if (window.currentEmojiPicker === this) {
          window.currentEmojiPicker = null;
        }
      }
    },
    updateWaiting(status) {
      this.waiting = status
    },
    updateEmojiState(emoji) {
      this.waiting = false
      if (!emoji) {
        this.selectedEmoji = "☺";
        this.isExist = false;
      } else {
        this.selectedEmoji = emoji;
        this.isExist = true;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.closePickerIfClickedOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closePickerIfClickedOutside);
    if (window.currentEmojiPicker === this) {
      window.currentEmojiPicker = null;
    }
  },
  watch: {
    existReaction: {
      immediate: true,
      handler(newValue) {
        this.isExist = newValue;
        this.selectedEmoji = newValue ? this.selectedEmoji : this.defaultEmoji;
      },
    },
  },
};
</script>

